$(document).ready(function () {
    $('.taxDialog').on('click', function (e) {
        e.preventDefault();

        var dialog = $(
            "[data-dialog='" + $(this).attr('id') + "']"
        );
        var closeButton = document.querySelector(
            "[data-dialog='" +
                $(this).attr('id') +
                "'] .closeModal"
        );
        $('body').addClass('Globo-not-scroll');
        closeButton.addEventListener('click', () => {
            $('body').removeClass('Globo-not-scroll');
            dialog[0].close();
        });

        dialog[0].showModal();
    });

    /*
    const dialog = document.getElementById("homecopyTaxDialog");
    const showButton = document.getElementById("homecopyTax");
    const closeButton = document.querySelector("#homecopyTaxDialog button");

    // "Show the dialog" button opens the dialog modally
    showButton.addEventListener("click", (e) => {
    e.preventDefault();
    dialog.showModal();
    });

    // "Close" button closes the dialog
    closeButton.addEventListener("click", () => {
    dialog.close();
    });*/
});